import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { unassignPayPalStoreAccount } from 'api/admin/stores/unassignPayPalStoreAccount';

export const useUnassignPayPalStoreAccount = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, number>({
    mutationFn: async (storeId) => {
      return unassignPayPalStoreAccount(storeId);
    },
    onSuccess: async () => {
      toaster('PayPal Account has been unassigned', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(
        error?.response?.data?.error ?? 'An error occurred while unassigning PayPal account',
        {
          icon: '❌',
        },
      );
      return error;
    },
  });
};
